import { type FormEventHandler, useState } from 'react';
import { isEmail } from '@witmetrics/utils/strings';
import FormHeading from '@/components/FormHeading';
import TextField from '@/components/inputs/TextField';
import Button from '@/components/Button';
import TextLink from '@/components/TextLink';
import { classes } from './utils';

export type ForgotPasswordFormProps = {
  isResettingPassword?: boolean;
  onReturnToLogin: () => void;
  onSubmit: (email: string) => void;
};

export default function ForgotPasswordForm({
  isResettingPassword,
  onReturnToLogin,
  onSubmit,
}: ForgotPasswordFormProps) {
  const [email, setEmail] = useState('');

  const isEnabled = isEmail(email);

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    if (isEnabled && !isResettingPassword) onSubmit(email.trim());
  };

  return (
    <form
      className={classes.form}
      name="forgot-password"
      onSubmit={handleSubmit}>
      <FormHeading
        className={classes.heading}
        title="Forgot your password?"
        subtitle="Enter your account email and we'll send you a link to reset your password."
      />
      <TextField
        autoFocus
        className={classes.email}
        name="email"
        type="email"
        label="Email *"
        autoComplete="email"
        value={email}
        onChange={setEmail}
      />
      <Button
        busy={isResettingPassword}
        disabled={!isEnabled}
        busyLabel="Requesting reset"
        type="submit">
        Request Reset
      </Button>
      <div className={classes.backWrapper}>
        <TextLink onClick={onReturnToLogin}>Back to login</TextLink>
      </div>
    </form>
  );
}
